import React from 'react';

const Button = ({ 
  children, 
  type = 'button', 
  variant = 'primary', 
  size = 'md',
  disabled = false,
  className = '',
  onClick,
  fullWidth = false,
  ...props 
}) => {
  const baseClasses = 'font-medium rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 min-h-[48px]';
  
  const variants = {
    primary: 'bg-[#00b894] text-white shadow-md hover:bg-[#00b894]/90 active:scale-95 focus:ring-[#00b894]/20',
    secondary: 'bg-gray-100 text-gray-700 border border-gray-200 hover:bg-gray-200 active:scale-95 focus:ring-gray-500/20',
    danger: 'bg-red-600 text-white shadow-md hover:bg-red-700 active:scale-95 focus:ring-red-500/20',
    outline: 'border-2 border-[#00b894] text-[#00b894] hover:bg-[#00b894] hover:text-white active:scale-95 focus:ring-[#00b894]/20',
    ghost: 'text-gray-700 hover:bg-gray-100 active:scale-95 focus:ring-gray-500/20',
  };
  
  const sizes = {
    sm: 'px-3 py-2 text-sm min-h-[40px]',
    md: 'px-4 py-3 text-sm min-h-[48px]',
    lg: 'px-6 py-4 text-base min-h-[56px]',
  };
  
  const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed active:scale-100' : '';
  const widthClasses = fullWidth ? 'w-full' : '';
  
  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${disabledClasses} ${widthClasses} ${className}`;
  
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button; 